import { Utils } from "@/plugins/utils";

export default {
	namespaced: true,
	state: {
		
	},
	getters: {
	
	},
	mutations: {
	
	},
	actions: {
		async printReportProductStock(store, params){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Imprimindo relatório", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.post("/Stock/Report/PrintReportProductStock", params)
			.then(response => {
				let relatPath = Utils.ValidateAxiosResponse(response.data);

				if(!!relatPath)
					store.dispatch("print/openRelatsPath", [ relatPath ], { root: true })
				
				if (!!params.exportPieces)
					store.dispatch("print/exportedFile", params.exportPiecesPath , { root: true })

				if (!!params.excel)
					store.dispatch("print/exportedFile", params.excelPath , { root: true })
				
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		async printReportStockPointOfSale(store, params){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Imprimindo relatório", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.post("/Stock/Report/PrintReportStockPointOfSale", params)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);

				if(payload && payload.relatPath)
					store.dispatch("print/openRelatsPath", [ payload.relatPath ], { root: true })
				
				if (params.eanCodification && payload && payload.eanCodificationPaths)
					for (const eanCodificationPath of payload.eanCodificationPaths) {
						store.dispatch("print/exportedFile", eanCodificationPath , { root: true })
					}
				
				if (params.negativeEAN)
					store.dispatch("print/exportedFile", params.negativeEANPath , { root: true })

				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		async updateStock(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Atualizando estoque", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.post("/Stock/Stock/UpdateStock")
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		async find(store, { pr0produto, pr2opcao = "", pr3tamanho = "", silent = false}){
			if(!silent)
				store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Buscando estoque do produto", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.get(`/Stock/Stock/Find?pr0produto=${pr0produto}&pr2opcao=${pr2opcao}&pr3tamanho=${pr3tamanho}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return 0
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		async findStocks(store, productSearchStockRequestModel){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Consultando dados", indeterminate: true }, { root: true })

			let payload = await this._vm.$axios.post(`/Stock/Stock/FindForProductSearch`, productSearchStockRequestModel)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return 0
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
	}
}